<template>
    <div class="homepage-container mb-xl">
        <div class="background-grad">
            <AonContainer add-page-padding class="pt-xxl pb-xl">
                <AonRow>
                    <AonCol class="grid-cols-12">
                        <h2
                            class="text-on-dark w-100 text-center mb-xxl"
                            data-cy="home-sub-title"
                            style="letter-spacing: normal"
                        >
                            {{ t('home.subTitle')
                            }}<span
                                class="text-stone-50"
                                style="font-size: 12px; display: ruby-text"
                                >(R)</span
                            >
                        </h2>
                    </AonCol>
                    <AonCol class="grid-cols-6 offset-3 justify-center">
                        <GlobalSearch />
                    </AonCol>
                </AonRow>
            </AonContainer>
            <AonContainer add-page-padding class="py-xs">
                <AonRow>
                    <AonCol
                        v-for="(card, index) in cardData"
                        :key="`car_${index}`"
                        class="discover-container grid-cols-6 p-sm"
                        :data-cy="card.dataCy"
                    >
                        <AonCard>
                            <div class="card-content">
                                <router-link
                                    class="text-decoration-none display-flex items-center"
                                    :to="{
                                        name: card.linkName,
                                    }"
                                >
                                    <font-awesome-icon
                                        :icon="`fas ${card.icon}`"
                                        class="text-on-dark icon-bordered bg-moat-900"
                                        size="3x"
                                    />
                                    <div
                                        class="link-content display-flex flex-column justify-between"
                                    >
                                        <div class="head mb-xs display-flex items-center">
                                            <h4 class="px-md text-moat-900">
                                                {{ card.title }}
                                            </h4>
                                            <font-awesome-icon
                                                icon="fas fa-chevron-right"
                                                class="text-moat-900 mt-xs"
                                                size="lg"
                                            />
                                        </div>
                                        <p class="text-stone-800 px-md" style="height: 50px">
                                            {{ card.desc }}
                                        </p>
                                    </div>
                                </router-link>
                            </div>
                        </AonCard>
                    </AonCol>
                </AonRow>
            </AonContainer>
        </div>

        <AonContainer add-page-padding>
            <AonRow>
                <AonCol class="grid-cols-12 p-sm mt-md">
                    <AonCard class="p-xl" title="Recent Activity">
                        <div class="tab-holder w-100">
                            <AonTabs
                                class="home-tabs mb-xl align-self-center light"
                                :current-tab="recentActivityCurrentTab"
                                :tabs="recentActivityTabData"
                                bottom-border
                                @tab-change="recentActivityTabChange"
                            />
                        </div>
                        <div class="recent-activity">
                            <WatchlistList v-if="recentActivityCurrentTab === 1" :key="updater" />
                            <PromptHistoryTable v-if="recentActivityCurrentTab === 2" />
                        </div>
                    </AonCard>
                </AonCol>
            </AonRow>
        </AonContainer>
    </div>
</template>

<script setup>
import { inject, ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useAppStore } from '@/stores'
import { useI18n } from 'vue-i18n'

import WatchlistList from '@/components/Watchlists/WatchlistList'
import GlobalSearch from '@/components/GlobalSearch'
import PromptHistoryTable from '@/components/home/PromptHistoryTable'

const { t } = useI18n()
const eventBus = inject('eventBus')

const updater = ref(0)
const recentActivityCurrentTab = ref(1)
const recentActivityTabData = ref([
    {
        text: 'Watchlists',
        id: 1,
    },
    {
        text: 'Prompt History',
        id: 2,
    },
])

const cardData = ref([
    {
        title: t('home.discoverCompaniesLink'),
        desc: t('home.discoverCompaniesDesc'),
        icon: 'fa-building',
        linkName: 'Companies',
        dataCy: 'discover-companies',
    },
    {
        title: t('home.defineArenaLink'),
        desc: t('home.defineArenaDesc'),
        icon: 'fa-swords',
        linkName: 'Arena',
        dataCy: 'define-arena',
    },
])

onMounted(() => {
    eventBus.on('updateWatchlistPage', async () => {
        updater.value++
    })
})

const recentActivityTabChange = (tab) => {
    recentActivityCurrentTab.value = tab.id
}
</script>

<style lang="scss" scoped>
@use '@moatmetrics/armory/src/sass/responsive.scss' as responsive;

.homepage-container {
    min-height: 100vh;
    height: 100%;

    :deep(.aon-container) {
        max-width: none;

        @include responsive.overSized {
            max-width: none;
        }
    }

    .background-grad {
        background: linear-gradient(180deg, #001d38 35.71%, #003a6f 100%);
    }

    .a-card {
        border-radius: 8px;
        // padding: 0 !important;

        .card-content {
            display: flex;
            align-items: center;

            .head {
                width: 100%;
                display: flex;
                align-items: center;
            }
        }
    }
}
</style>
